<template>
        <crud-update :open="open"
                 :loading="loading"
                 :title="title"
                 :errorMessage="errorMessage"
                 @update="update"
                 @close="$emit('close')"
    >
         <movimiento-form ref="form" v-model="form" :input-errors="inputErrors" />
    </crud-update>
</template>

<script>

    import MovimientoProvider from "../../../providers/MovimientoProvider";
    
    import {CrudUpdate, ClientError} from '@dracul/common-frontend'
    
    import MovimientoForm from "../MovimientoForm";
  
    import {Dayjs} from "@dracul/dayjs-frontend";

    export default {
        name: "MovimientoUpdate",
        
        components: { MovimientoForm, CrudUpdate },
        
        props:{
          open: {type: Boolean, default: true},
          item: {type: Object, required: true}
        },

        data() {
            return {
                title: 'movimiento.editing',
                errorMessage: '',
                inputErrors: {},
                loading: false,
                form: {
                     id: this.item.id,
                    productos: this.item.productos.map(i=> i.id?i.id:i),
                    cantidad: this.item.cantidad,
                    fecha: this.item.fecha?Dayjs(parseInt(this.item.fecha)):null
                }
            }
        },
        methods: {
            update() {
                if (this.$refs.form.validate()) {
                    this.loading = true
                    MovimientoProvider.updateMovimiento(this.form).then(r => {
                            if (r) {
                                this.$emit('itemUpdated',r.data.movimientoUpdate)
                                this.$emit('close')
                            }
                        }
                    ).catch(error => {
                         let clientError = new ClientError(error)
                         this.inputErrors = clientError.inputErrors
                         this.errorMessage = clientError.i18nMessage
                    }).finally(() => this.loading = false)
                }

            }
        },
    }
</script>

<style scoped>

</style>

